//import { useEffect } from "react";
import { minutesToSeconds, secondsToMilliseconds } from "../../helpers/date";
//import { retryWithExponentialBackOff } from "../../helpers/function";
import { IUser } from "../../interfaces";
import AuthService from "../../services/auth-service";
import { default as useCurrentUserHook, clearCachedUser } from "./current-user";

//export { useCurrentUserHook as useCurrentUser };
export { clearCachedUser as clearCachedUser };

let expiry: number = 0;
const msToExpire: number = secondsToMilliseconds(minutesToSeconds(1));


export function useCurrentUser(): [IUser | null, boolean, typeof proxyFetchCurrentUser, typeof setCurrentUser] {
  const [currentUser, isFetchingCurrentUser, fetchCurrentUser, setCurrentUser] = useCurrentUserHook();

  async function proxyFetchCurrentUser() {
    // Because a user might manually call the proxyFetchCurrentUser (exported as fetchCurrentUser) 
    // We want to ensure that: 
    // If the user is not logged in, no need to call the `/authenticate` API endpoint.
    // This will be the case when AuthService.isAuthenticatedUser() is false. 
    // AuthService.isAuthenticatedUser() checks to see if an access token is set.
    // The access token is set when the user logs in from the login form 
    // and is unset when the user logs out.
    // So, if the user is logged-in, it will be set. Otherwise, it will not be set.
    // We make use of that knowledge to avoid calling the `/authenticate` API endpoint 
    // unnecessarily when the user is not logged in.
    //
    // If the user is logged-in, however, that is, access token is set, 
    // then, we proceed below to check whether their access token is still valid 
    // or if a fetch user request is currently ongoing. 
    // Only if all these fail do we finally make a request to the `/authenticate` API endpoint.
    if(!AuthService.isAuthenticatedUser()) { 
      return null;
    }

    // Because a user might manually call the proxyFetchCurrentUser (exported as fetchCurrentUser) 
    // We want to ensure that if a fetchCurrentUser request is already in progress 
    // or an arbitrary expiry time has not passed, their new request should not be fired.
    if(expiry > Date.now() || isFetchingCurrentUser) {
      return;
    }

    //retryWithExponentialBackOff(async () => {
      // fetchCurrentUser (augmented and returned by useCurrentUserHook() which is returned by createDataHook()) 
      // also automatically calls setCurrentUser() 
      // with the data of the returned user. 
      // However, it also returns the current user's data.
      // So, we can manually also call setCurrentUser with the returned user's data.
      await fetchCurrentUser(); 
      
      expiry = (Date.now() + msToExpire);
    //});
  }

  // Move this to the initializeApp hook 
  // That way, we don't make a fetchCurrentUser() request 
  // every time a component that uses this hook mounts.
  // Instead, we make a fetchCurrentUser() the first time the application (App component) mounts.
  // Then, fetchCurrentUser() is only ever called again by components that need it to be called, 
  // for example, Wishlist, OrderListing, and themes/limupa/header/helper-components/wishlist-count.
  /*useEffect(() => {
    if(!currentUser) {
      proxyFetchCurrentUser();
    }
  }, []);*/

  return [currentUser, isFetchingCurrentUser, proxyFetchCurrentUser, setCurrentUser];
}

/*export function usePreFetchedCurrentUser(): [IUser | null, boolean, boolean, typeof setCurrentUser] {
  const userFetchedRef = useRef(false); 
  const [prevUser, setPrevUser] = useState<IUser|null>(null);
  const [currentUser, isFetchingCurrentUser, fetchCurrentUser, setCurrentUser] = useCurrentUserHook();

  useEffect(() => {
    if(currentUser !== prevUser) {
      setPrevUser(currentUser);
    }
  }, [currentUser, prevUser]);
    
  useEffect(() => {
    if(!currentUser && !userFetchedRef.current && !isFetchingCurrentUser) {
      fetchCurrentUser().then((res) => {
        userFetchedRef.current = true;
      });
    }
  }, [currentUser, isFetchingCurrentUser, userFetchedRef.current]);

  return [currentUser, isFetchingCurrentUser, userFetchedRef.current, setCurrentUser];
}*/
